customElements.get("product-zoom") || customElements.define("product-zoom", class extends HTMLElement {
  constructor() {
    super(), this.slider = this.querySelector(":scope [data-slider]"), this.showArrow = this.showArrow.bind(this), 
    this.hideArrow = this.hideArrow.bind(this), this.update = this.update.bind(this), 
    this.scroll = this.scroll.bind(this);
  }
  connectedCallback() {
    if (!this.slider) return !1;
    this.slides = this.getSlides(), this.prev = this.querySelector(":scope [data-prev]"), 
    this.next = this.querySelector(":scope [data-next]"), this.addEventListeners(), 
    this.update(), this.setActiveSlide();
  }
  getSlides() {
    return this.querySelectorAll(":scope [data-slider] > [data-slide]");
  }
  scroll(e, t = !1) {
    t && t.preventDefault() && t.stopPropagation();
    const s = "previous" === e ? Math.min(this.getIndex() - 1, this.slides.length - 1) : Math.max(this.getIndex() + 1, 0);
    this.goTo(s);
  }
  goTo(e, t = "smooth", s = !1) {
    s && s.preventDefault() && s.stopPropagation(), this.slides[e]?.scrollIntoView({
      behavior: t
    });
  }
  hideArrow(e) {
    e.disabled = !0, e.ariaDisabled = !0;
  }
  showArrow(e) {
    e.disabled = !1, e.ariaDisabled = !1;
  }
  updateArrows() {
    this.slider.scrollTop > 0 ? this.showArrow(this.prev) : this.hideArrow(this.prev), 
    this.slider.scrollTop + this.slider.offsetHeight < this.slider.scrollHeight - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-offset")) ? this.showArrow(this.next) : this.hideArrow(this.next);
  }
  getIndex() {
    const e = [ ...this.slides ].find((e => "true" === String(e.ariaCurrent))), t = [ ...this.slider.children ].indexOf(e);
    return Math.max(t, 0);
  }
  update() {
    this.updateArrows();
  }
  setActiveSlide() {
    window.index && (this.goTo(window.index, "instant"), window.index = !1);
  }
  addEventListeners() {
    this.prev.addEventListener("click", (e => this.scroll("previous", e))), this.next.addEventListener("click", (e => this.scroll("next", e)));
    const e = new IntersectionObserver((e => {
      e.forEach((e => e.target.ariaCurrent = !!e.isIntersecting));
    }), {
      root: this.slider,
      threshold: .1
    });
    this.slides.forEach((t => e.observe(t))), [ "scroll", "scrollend" ].forEach((e => {
      this.slider.addEventListener(e, this.update, {
        passive: !0
      });
    })), this.slider.addEventListener("mouseenter", this.update, {
      passive: !0
    }), this.closest("details")?.addEventListener("toggle", (e => {
      e.target.open && (this.setActiveSlide(), this.update());
    }), {
      passive: !0
    });
  }
});